export default __webpack_public_path__ + "static/media/Saudi_Riyal_Symbol-1.20207e1e.png";